import React from "react";
import PropTypes from "prop-types";
import ReportHeader from "./ReportHeader";
import { TR } from "./BusinessDashboard/Table/Table";

const AgentTextsHeaders = ({ sortBy, sortKey, sortDesc }) => (
  <TR>
    <ReportHeader name="agent" sortDesc={sortDesc} sortKey={sortKey} label="Name" handleSort={sortBy} />
    <ReportHeader
      name="text_report_agent_total_lead_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Leads"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_lead_text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Leads Texted"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_non_lead_text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Others Texted"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_total_texts"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Texts Sent"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_total_texts_recd"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Texts Received"
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_report_total_text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Total Texts"
      handleSort={sortBy}
    />
  </TR>
);

AgentTextsHeaders.propTypes = {
  sortBy: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
};

export default AgentTextsHeaders;
